module.exports = __webpack_public_path__ + "static/img/newse.16b9874.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newse.png
// module id = Fb1B
// module chunks = 45